
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprar-grama/[province]/[city]",
      function () {
        return require("private-next-pages/comprar-grama/[province]/[city].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comprar-grama/[province]/[city]"])
      });
    }
  